import './index.scss';
import classnames from 'classnames';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
import ComparisonsTab from './comparisons_tab';
import DocumentTab from './document_tab';
import TabsView from './tabs_view';
export const RecentActivityTabs = {
    DOCUMENTS: 'documents',
    DOCUMENT_COMPARISON: 'document-comparison',
};
const CenterPanel = () => {
    const { tab: activeTab } = useParams();
    const { hasPermission } = useUser();
    const hasMultipleTabs = hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENTS) &&
        hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENT_COMPARISONS);
    const showRightPanel = hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENT_COMPARISONS) &&
        ((!hasMultipleTabs && activeTab === undefined) ||
            activeTab === RecentActivityTabs.DOCUMENT_COMPARISON);
    const mainPanelClasses = classnames('recent-activity-center-panel', { partial: showRightPanel });
    return (React.createElement("div", { className: mainPanelClasses }, hasMultipleTabs
        ? React.createElement(TabsView, null)
        : hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENT_COMPARISONS)
            ? React.createElement(ComparisonsTab, null)
            : hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENTS)
                ? React.createElement(DocumentTab, null)
                : React.createElement(React.Fragment, null)));
};
export default CenterPanel;
